const CheckStepsEN = {
  CheckSteps: {
    COMPLETE_LATER: 'Complete later',
    TITLE: 'We are almost there!',
    SUBTITLE: 'There are some steps that still need to be completed.',
    'BUSINESS-MANAGER': 'Business Manager',
    TEXT: 'Accept each of the items below on the ',
    TOOLTIP: 'A platform that allows to manage multiple pages and ad accounts, including yours.',
  },
};

const CheckStepsPT = {
  CheckSteps: {
    COMPLETE_LATER: 'Completar depois',
    TITLE: 'Estamos quase lá!',
    SUBTITLE: 'Existem algumas etapas que ainda necessitam ser realizadas.',
    'BUSINESS-MANAGER': 'Gerenciador de Negócios',
    TEXT: 'Aceite cada um dos items abaixo no ',
    TOOLTIP: 'Plataforma que permite gerenciar diversas páginas e contas de anúncios, inclusive a sua.',
  },
};

export { CheckStepsPT, CheckStepsEN };
